import React from "react";
import useStyles from "../../style/js-style/containers/thirdparties/sheet/PanelIndicatorStyle";
import EAIcon from "../common/EAIcon";
import moment from "moment";
import i18next from "i18next";
import { Tooltip } from "@mui/material";
import _ from "lodash";
import { 
  formatCalculationResult
} from "services/common/CalculatorUtils";
import { theme } from "style/globalStyle";
import EAColorIcon from '../common/EAColorIcon';
import { lightenHex } from '../../services/common/Utils';

const IndicatorNoData = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.rootNoData}>
      <EAIcon icon="indicator-search" />
      <span className={classes.noDataText}>{i18next.t('calculator.indicator.noIndicators')}</span>
    </div>
  );
}

const ColoredSmallIcon = ({color}) => {
  return (
    <svg width="19" height="23" viewBox="0 0 19 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group">
      <path id="Vector" d="M18.875 5.56258C18.875 4.73966 18.3854 3.98966 17.6354 3.65633L10.3438 0.416748C9.80208 0.177165 9.1875 0.177165 8.65625 0.416748L1.36458 3.65633C0.614583 3.98966 0.125 4.73966 0.125 5.56258V10.4584C0.125 16.2397 4.125 21.6459 9.5 22.9584C11.8958 22.3751 14.0104 20.9792 15.625 19.0938L12.375 15.8438C10.3542 17.1876 7.60417 16.9584 5.82292 15.1772C3.79167 13.1459 3.79167 9.84383 5.82292 7.81258C7.85417 5.78133 11.1562 5.78133 13.1875 7.81258C14.9687 9.59383 15.1875 12.3438 13.8542 14.3647L16.875 17.3855C18.1354 15.3438 18.875 12.9376 18.875 10.4584V5.56258Z"
      fill={color}/>
      <path id="Vector_2" d="M9.5 14.625C11.2259 14.625 12.625 13.2259 12.625 11.5C12.625 9.77411 11.2259 8.375 9.5 8.375C7.77411 8.375 6.375 9.77411 6.375 11.5C6.375 13.2259 7.77411 14.625 9.5 14.625Z"
      fill={color}/>
      </g>
      </svg>
  )
}

const IndicatorItem = ({itemData}) => {
  const { classes } = useStyles();
  const color = itemData.resultColorCode ? itemData.resultColorCode : "#E2E2EA";

  const TooltipTextScore = ({color, score}) => {
    return (
      <div className={classes.tooltipScoreText}>
        <span>{i18next.t("ESG.score")} </span>
        <span style={{color: color }}>{score}</span>
      </div>
    )
  }

  return (
    <div className={itemData.subScores ? classes.subScoresWrapper : undefined}>
      <div className={classes.rootItem}>

        <div className={classes.itemIcon} style={{backgroundColor: lightenHex(color, 0.8)}}>
          <EAColorIcon icon={"indicator_pin"} color={color} svgStyle={{position: "relative", top: "1px"}}/>
          <Tooltip title={itemData?.name?.length > 22 ? itemData.name : ''}>
            <div className={classes.itemName}>
              {itemData.name}
            </div>
          </Tooltip>
        </div>

        <div className={classes.itemContent}>
          <Tooltip title={itemData?.resultValue?.length > 22 ? itemData.resultValue : ''}>
            <div className={classes.itemResult}>
            {formatCalculationResult(itemData)}
            </div>
          </Tooltip>
        </div>

        <div className={classes.itemUpdate}>
          { itemData.resultLastUpdateDate &&
            <>
              <span>{itemData.resultLastUpdateDate && i18next.t('calculator.indicator.updateDate')}</span>
              <span>{moment(itemData.resultLastUpdateDate).format(i18next.t('date.dateFormat'))}</span>
            </>
          }
        </div>
      </div>
      {itemData.subScores &&
          <div>
            <div className={classes.subScoresTitle}>{i18next.t("ESG.evoluationsLabel")}</div>
            <div className={classes.subScoresItemsWrapper}>
              {itemData.subScores.map(score => {
                  return (
                  <div className={classes.subScoresItem}>
                    <Tooltip title={<TooltipTextScore color={score.resultColorCode} score={score.resultValue}/>}
                    placement="top" arrow componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: theme.palette.background.white,
                          color: theme.palette.grey.grey500,
                          padding: "10px",
                          boxShadow: "5px 5px 30px " + theme.palette.grey.grey200,
                          '& .MuiTooltip-arrow': {
                            color: theme.palette.background.white,
                          },
                        },
                      },
                    }}>
                      <div className={classes.subScoresItemIcon} style={{backgroundColor: score.resultColorCode + "20",
                        boxShadow: `0px 6.031px 12.955px 0px ${score.resultColorCode + "30"}, 0px 3.381px 7.263px 0px ${score.resultColorCode + "20"}, 0px 1.796px 3.857px 0px ${score.resultColorCode + "10"}, 0px 0.747px 1.605px 0px ${score.resultColorCode + "05"}`
                        }}>
                          <ColoredSmallIcon color={score.resultColorCode} />
                      </div>
                    </Tooltip>
                    <div className={classes.subScoresItemTitle}>{score.name}</div>

                  </div>)
              })

              }
            </div>
          </div>
      }
    </div>
  );
}

function PanelIndicators({ indicators, bondType }) {
  const { classes } = useStyles();

  if(_.isEmpty(indicators)) return <IndicatorNoData />
  else{
   return (
     <div className={classes.rootData}>
       {
         indicators.map((indicator) => (
           <IndicatorItem key={indicator.id} itemData={indicator} />
         ))
       }
     </div>
   )
  }
}

export default PanelIndicators;
